// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C2n4","left":"styles_left__gA6uf"};